import React from 'react'
import cn from 'classnames'
import { observer } from 'mobx-react'

import BootstrapStore from 'stores/bootstrap/BootstrapStore'
import ThemeStore from 'stores/theme/ThemeStore'
import TabStore from 'stores/tab/TabStore'
import { MODEL_LIST_TAB_ID } from 'stores/tab/Tab'
import {
  SessionContextProvider,
  SessionContext,
} from 'stores/session/SessionContext'
import UpdateStore from 'stores/update/UpdateStore'
import ConfigStore from 'stores/config/ConfigStore'

import Skeleton from 'components/skeleton/Skeleton'
import Layout from 'components/layout/Layout'
import Mousetrap from 'components/mousetrap/Mousetrap'
import ShortcutDialog from 'components/shortcutDialog/ShortcutDialog'

import styles from './studio.scss'

interface IState {
  isShortcutDialogOpen: boolean
}

class Studio extends React.Component<{}, IState> {
  state: IState = {
    isShortcutDialogOpen: false,
  }

  async componentDidMount() {
    if (!UpdateStore.hasCheckedForUpdates) {
      // If we have already checked for updates once, don't auto-check again
      // This makes it so an update check only happens when the user explicitly requests it
      // This is useful to avoid excessive update checks
      await UpdateStore.check()
    }
  }

  render() {
    const { isShortcutDialogOpen } = this.state

    return (
      <>
        <div
          className={cn(styles.container, {
            'theme--light': ThemeStore.theme === 'light',
            'theme--dark': ThemeStore.theme === 'dark',
          })}
        >
          {BootstrapStore.ready && TabStore.activeTab ? (
            <SessionContextProvider
              value={
                new SessionContext({ sessionId: TabStore.activeTab.sessionId })
              }
            >
              <Layout />
            </SessionContextProvider>
          ) : (
            <Skeleton />
          )}

          <div id="modal-root"></div>
          <div id="dropdown-root"></div>
          <div id="dialog-root"></div>
        </div>

        {/* Global Shortcuts */}

        {!ConfigStore.isBrowser && (
          <>
            <Mousetrap
              keys="mod+t"
              onMatch={() => TabStore.switch({ id: MODEL_LIST_TAB_ID })}
            />
            <Mousetrap
              keys="mod+w"
              preventDefault
              stopPropagation
              onMatch={() => {
                console.log('gg')
                TabStore.remove(TabStore.activeTabId)
              }}
            />
            <Mousetrap
              keys={[
                'command+shift+]' /* macos only */,
                'command+option+right' /* macos only */,
                'ctrl+tab' /* windows / linux */,
              ]}
              onMatch={() => TabStore.switch({ direction: 'right' })}
            />
            <Mousetrap
              keys={[
                'command+shift+[' /* macos only */,
                'command+option+left' /* macos only */,
                'ctrl+shift+tab' /* windows / linux */,
              ]}
              onMatch={() => TabStore.switch({ direction: 'left' })}
            />
          </>
        )}
        <Mousetrap
          keys="mod+/"
          onMatch={() =>
            this.setState(state => ({
              isShortcutDialogOpen: !state.isShortcutDialogOpen,
            }))
          }
        />

        {/* Global dialogs */}
        {isShortcutDialogOpen && (
          <ShortcutDialog
            onClose={() => this.setState({ isShortcutDialogOpen: false })}
          />
        )}
      </>
    )
  }
}

export default observer(Studio)
